import AuthGuard from "components/authentication/AuthGuard";
import GuestGuard from "components/authentication/GuestGuard";
import DashboardLayout from "components/Layouts/DashboardLayout";
import LoadingScreen from "components/LoadingScreen";
import {FC, lazy, LazyExoticComponent, Suspense} from "react";
import {Navigate} from "react-router-dom";
import Trips from "./pages/trips";
import Drivers from "./pages/drivers";
import RolesPage from "./pages/roles";
import PrivacyPolicy from "./pages/privacy-policy";
import TermsOfUse from "./pages/terms-of-use";


const Loadable = (Component: LazyExoticComponent<FC>) => (props: any) =>
    (
        <Suspense fallback={<LoadingScreen/>}>
            <Component {...props} />
        </Suspense>
    )

// authentication pages
const Login = Loadable(lazy(() => import("./pages/authentication/Login")));

const ForgetPassword = Loadable(
    lazy(() => import("./pages/authentication/ForgetPassword"))
)

// Dashboard pages
const DashboardSaaS = Loadable(lazy(() => import("./pages/dashboard")));

// user profile
const UserProfile = Loadable(lazy(() => import("./pages/UserProfile")));

// user management
const UserList = Loadable(
    lazy(() => import("./pages/users"))
)

// error
const Error = Loadable(lazy(() => import("./pages/404")));

// routes
const routes = [
    {
        path: "/",
        element: <Navigate to="dashboard"/>,
    },
    {
        path: "login",
        element: (
            <GuestGuard>
                <Login/>
            </GuestGuard>
        ),
    },
    {
        path: "forget-password",
        element: (
            <GuestGuard>
                <ForgetPassword/>
            </GuestGuard>
        ),
    },
    {
        path: "privacy-policy",
        element: <PrivacyPolicy/>
    },
    {
        path: "terms-of-use",
        element: <TermsOfUse/>
    },
    {
        path: "dashboard",
        element: (
            <AuthGuard>
                <DashboardLayout/>
            </AuthGuard>
        ),
        children: [
            {
                path: "",
                element: <DashboardSaaS/>,
            },
            {
                path: "user-profile",
                element: <UserProfile/>,
            },
            {
                path: "users",
                element: <UserList/>,
            },
            {
                path: "roles",
                element: <RolesPage/>,
            },
            {
                path: "drivers",
                element: <Drivers/>,
            }, {
                path: "trips",
                element: <Trips/>,
            },

        ],
    },
    {
        path: "*",
        element: <Error/>,
    },
];

export default routes;
